import { render, staticRenderFns } from "./AiAssistantSider.vue?vue&type=template&id=2f9eafee&scoped=true&"
import script from "./AiAssistantSider.vue?vue&type=script&lang=js&"
export * from "./AiAssistantSider.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantSider.vue?vue&type=style&index=0&id=2f9eafee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9eafee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9eafee')) {
      api.createRecord('2f9eafee', component.options)
    } else {
      api.reload('2f9eafee', component.options)
    }
    module.hot.accept("./AiAssistantSider.vue?vue&type=template&id=2f9eafee&scoped=true&", function () {
      api.rerender('2f9eafee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/modal/AiAssistantDrawer/AiAssistantSider.vue"
export default component.exports